//#region imports
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class Globals {
  //#region variables
  isClient = false;
  property = 0;
  p5xPrvDisable = false;
  languagecode = 'FR';
  characteristicsSelected = false;
  detailsSelected = false;
  guaranteeSelected = false;
  recapSelected = false;
  signatureSelected = false;
  calculateError = false;
  check = false;
  postalCodeInvalidWarning = false;
  quesWarning = false;
  fbqpixelcharpage = false;
  sendSimulationMail = false;
  ques1Warning = false;
  ques2Warning = false;
  ques3Warning = false;
  ques4Warning = false;
  ques5Warning = false;

  detailsHeader: string;

  guaranteeHeader1 = false;
  guaranteeHeader2 = false;
  detailsRouter: any;

  locationData: any;
  filteredLocality: Observable<string[]>;
  filteredLocation: any;
  postalCode: any;
  propertyPostCode: any;


  countryData: any;
  selectedCountry: any;
  filteredCountry: any;

  paymentFrequency: any;
  paymentFrequencyPercent: any;
  paymentFrequencyanswer:any;

  generateSimulation:boolean=false;
  SimulationDocumentum:boolean = false;
  mapValues:any=[]; 
  abexValueGlobal: string;
  showLoaderText: boolean=false;
  showprojectText: boolean = false;
  totalPremium: any;
  isDesktop: boolean = false;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isContentFirsttime = false;
  isTheftZero = false;
  congratsTitleFR: string;
  congratsTitleNL:string;
  federaleURL: string;
  trackPageActivity: string='';
  charpage1: boolean= false;
  charpage2: boolean = false;
  charpage3: boolean= false;
  charpage4: boolean = false;
  charpage5: boolean= false;

  //#endregion
}
